import { render } from "./delivery-challan-return-modal.vue?vue&type=template&id=771555b8"
import script from "./delivery-challan-return-modal.vue?vue&type=script&lang=js"
export * from "./delivery-challan-return-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__